<template>
  <el-scrollbar ref="scrollbar">
    <el-form ref="form" label-width="150px" size="mini">
      <el-col :span="12">
        <el-form-item label="默认快速查询：">
          <el-select v-model="formData.quickSearchItem" filterable placeholder="请选择" style="width: 100%">
            <el-option label="" value=""></el-option>
            <el-option
              v-for="item in quickSearchItems"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="默认报告类型：">
          <el-select v-model="formData.reportType" filterable placeholder="请选择" style="width: 100%">
            <el-option label="" value=""></el-option>
            <el-option
              v-for="item in specimenSourceList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-form>
  </el-scrollbar>
</template>

<script>
  import {keyCodes, dictionaryDatas} from "../commons"

  export default {
    //name: "SysSetting",
    data() {
      return {
        quickSearchItems: dictionaryDatas.quickSearchItems,
        specimenSourceList: dictionaryDatas.specimenSourceList,
        formData: {
          quickSearchItem: null,
          reportType: null
        }
      }
    },
    methods: {
      initData() {
        const _this = this;
        //处理系统参数配置
        if (_this.$store.state.userSetting) {
          _this.$store.state.userSetting.forEach(item => {
            switch (item.setting_code) {
              case keyCodes.QUICK_SEARCH_SETTING_CODE:
                //定位快速查询 项
                _this.formData.quickSearchItem = item.setting_value;
                break;
              case keyCodes.SPEC_SOURCE_SETTING_CODE:
                _this.formData.reportType = item.setting_value;
                break;
            }
          });
        }
      },
      saveData() {
        const _this = this;
        let params = {
          settings: [],
          userJson: {orgId: _this.$store.state.userInfo.org_id}
        }

        if(_this.formData.quickSearchItem){
          params.settings.push({setting_code:keyCodes.QUICK_SEARCH_SETTING_CODE, setting_value: _this.formData.quickSearchItem});
        }
        if(_this.formData.reportType){
          params.settings.push({setting_code:keyCodes.SPEC_SOURCE_SETTING_CODE, setting_value: _this.formData.reportType});
        }
        _this.$store.dispatch('loading');
        _this.apiSystem.saveUserSetting(_this.$store.state.userInfo.org_id, _this.$store.state.userInfo.id,
          params,
          () => {
            _this.$alert("保存成功，重新登陆后生效", '提示', {type: 'success'});
            _this.$store.dispatch('loaded');
            _this.$emit('onSaved');
          },
          (error) => {
            _this.$alert("加载用户参数配置发生异常：" + error.message, '异常', {type: 'error'});
            _this.$store.dispatch('loaded');
          }
      );
    }
  }
  ,
  mounted()
  {
    const _this = this;
    _this.initData();
  }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SysSetting.vue